import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  AppBar,
  Toolbar,
  Badge,
  Hidden,
  IconButton,
  Typography
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none'
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  }
}));

const Topbar = props => {
  const { className, onSidebarOpen, ...rest } = props;

  const classes = useStyles();

  const [notifications] = useState([]);
  // const [hearts, setHearts] = useState([]);
  // const heartsAmount = 20;

  // useEffect(() => {

  //   const browserWidth = document.documentElement.clientWidth;
  //   const reds = ['#ff001a','#ff1129','#ee0018','#ff3348','#990010','#ff6676','#ff4457']

  //   const maxOffset =  Math.ceil(browserWidth/ heartsAmount)
  //   let newHearts = []
  //   for (let i=0; i<heartsAmount; i++){
  //     const marginLeft = i * maxOffset + Math.floor(Math.random() * maxOffset)
  //     const color = Math.floor(Math.random() * reds.length)
  //     const size = Math.floor(Math.random() * 3)
  //     // newHearts.push({id:i,left:marginLeft,color:`classes.color${color}`})
  //     newHearts.push({id:i,left:marginLeft,color:`color${color}`, size: `size${size}`})

  //   }

  //   setHearts(newHearts)
  // }, []);

  // useEffect(() => {

  //   for (let i=0; i<heartsAmount; i++){
  //     animateHeart(`heart${i}`);
  //   }

  // }, [hearts]);

  return (
    <AppBar {...rest} className={clsx(classes.root, className)}>
      <Toolbar id={'toolbar'}>
        {/* <RouterLink to="/">
          <img
            alt="Logo"
            src="/images/logos/logo--white.svg"
          />
        </RouterLink> */}
        {/* <Typography variant="h2" style={{color: 'white'}}>❤️❤️ C днем рождения  ❤️❤️ </Typography> */}
        {/* <div className={classes.heartShape} style={{left:200,top:200}}></div> */}

        <div className={classes.flexGrow} />
        <Hidden mdDown>
          <IconButton color="inherit">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot">
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <IconButton className={classes.signOutButton} color="inherit">
            <InputIcon />
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onSidebarOpen}>
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default Topbar;
